import styled, { css } from 'styled-components';

// Import styles utilities
import { flex, transitionMain, customMinResponsive } from 'components/styles';

export const Wrapper = styled.div`
	flex: 1;
	${flex({ jc: 'flex-end', ai: 'center' })};
`;

export const MenusContainer = styled.div`
	position: absolute;
	top: 0;
	margin-top: 6.5rem;
	left: -1.2rem;
	width: 100vw;
	z-index: 99999;
	cursor: pointer;
	overflow: hidden auto;
	height: 0;
	${transitionMain}

	&.entered {
		height: auto;
	}

	${customMinResponsive(
		400,
		css`
			left: -2.2rem;
		`
	)}
`;
